<template>
    <div class="container">
        <div class="content">
            <paydailog v-model="showpay" :totalPrice="totalPrice"  :paysrc="paysrc" :outTradeNo="out_trade_no" :payType="payType"></paydailog>
            <login v-model="loginModel" @callback="getLogin"></login>
            <help v-model="helpModel"></help>
            <agree v-model="agreeModel"></agree>
            <div style="display:none">
                <canvas id="canvas" width="0px" height="0px" style="dispaly: none"></canvas>
            </div>
            <el-card style="width: 100%;">
                <div slot="header" class="clearfix vio-header">
                    <span style="color: #002257;font-size: 20px;">违章处理</span>
                    <!-- <img src="../assets/app.png" alt="" class="imgfont" @mouseover='app(true)' @mouseout="app(false)"> -->
                    <div class="app-download" v-if="showapp">
                        <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/officeweb/code-vio.png" alt="" style="width:175px;height: 175px;">
                        <img src="../assets/app_sale.png" alt="" style="width:223px;height: 68px;">
                    </div>
                </div>
                <div style="background: #FAFDFF;border: 1px solid #EBEDF7;padding: 20px 30px;">
                    <div class="form-title">
                        <span style="color: #002257;font-size: 20px;" v-if="illegal.CarNo">{{illegal.CarNo}}</span>
                        <span class="fine">罚{{ price|| 0 }}元</span>
                    </div>
                    <div class="pay-container">
                        <el-form label-width="125px" class="payform" size="small">
                            <el-form-item label="手机号码">
                                <el-input v-model="phone" placeholder="请输入手机号码" />
                            </el-form-item>
                            <el-form-item label="驾驶证号" v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.drive_no == 1">
                                <el-input v-model="driveNo" placeholder="请输入驾驶证号码" />
                            </el-form-item>
                            <el-form-item label="驾驶证档案编号" v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.drive_file_number == 1">
                                <el-input v-model="drive_file_number" placeholder="请输入驾驶证档案编号" />
                            </el-form-item>
                            <el-form-item label="驾驶证条形码编号" v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.drive_bar_code == 1">
                                <el-input v-model="drive_bar_code" placeholder="请输入驾驶证条形码编号" />
                            </el-form-item>
                            <el-form-item label="行驶证正面" v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.drive_licence == 1">
                                <img v-if="driveUrl"  :src="driveUrl" style="width:200px;height: 100px;" />
                                <el-button size="small" v-show="driveUrl" type="text" style="margin-left:20px" @click="chooseImage">重新上传</el-button>
                                <div v-show="!driveUrl" @click="chooseImage">
                                    <!-- <el-button type="primary" size="small">上传照片</el-button> -->
                                    <div class="upload">
                                        <img src="../assets/upload.png" style="width:24px;height: 24px;" alt="">
                                        <span>上传图片</span>
                                    </div>
                                    <input type="file" accept="image/*" @change="uploader" ref="file" multiple="multiple" style="display: none;">
                                </div>
                            </el-form-item>
                            <el-form-item label="行驶证反面" v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.travel_licence == 1">
                                <img v-if="travelUrl"  :src="travelUrl" style="width:50px" />
                                <el-button size="small" v-show="travelUrl" type="text" style="margin-left:20px" @click="chooseTravel">重新上传</el-button>
                                <div v-show="!travelUrl" @click="chooseTravel">
                                    <!-- <el-button type="primary" size="small">上传照片</el-button> -->
                                    <div class="upload">
                                        <img src="../assets/upload.png" style="width:24px;height: 24px;" alt="">
                                        <span>上传图片</span>
                                    </div>
                                    <input type="file" accept="image/*" @change="uploaderXSZTravel" ref="XSZTravel" multiple="multiple" style="display: none;">
                                </div>
                            </el-form-item>
                            <el-form-item label="驾驶证正面" v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.jsz_drive_licence == 1">
                                <img v-if="JSZDriveUrl"  :src="JSZDriveUrl" style="width:50px" />
                                <el-button size="small" v-show="JSZDriveUrl" type="text" style="margin-left:20px" @click="chooseJSZDrive">重新上传</el-button>
                                <div v-show="!JSZDriveUrl" @click="chooseJSZDrive">
                                    <el-button type="primary" size="small">上传照片</el-button>
                                    <input type="file" accept="image/*" @change="uploaderJSZDrive" ref="JSZDrive" multiple="multiple" style="display: none;">
                                </div>
                            </el-form-item>
                            <el-form-item label="驾驶证反面" v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.jsz_travel_licence == 1">
                                <img v-if="JSZTravelUrl"  :src="JSZTravelUrl" style="width:50px" />
                                <el-button size="small" v-show="JSZTravelUrl" type="text" style="margin-left:20px" @click="chooseJSZTravel">重新上传</el-button>
                                <div v-show="!JSZTravelUrl" @click="chooseJSZTravel">
                                    <el-button type="primary" size="small">上传照片</el-button>
                                    <input type="file" accept="image/*" @change="uploaderJSZTravel" ref="JSZTravel" multiple="multiple" style="display: none;">
                                </div>
                            </el-form-item>
                        </el-form>
                        <div style="width:1px;background:#E6E6E6;margin:0 30px;"></div>
                        <el-form label-width="100px" class="payform" size="small">
                            <el-form-item label="罚款金额">
                                <span>{{ price|| 0 }}</span> 元
                            </el-form-item>
                            <el-form-item label="滞纳金">
                                <span>{{ lateFree|| 0 }}</span> 元
                            </el-form-item>
                            <el-form-item label="服务费">
                                <span>{{ ownFree|| 0 }}</span> 元
                            </el-form-item>
                            <el-form-item label="合计">
                                <span style="width:auto;color:#F75A00;font-weight:bold;font-size:20px" >{{ (((price * 100 + ownFree * 100 + lateFree * 100) || 0) / 100).toFixed(2) }}</span> 元
                            </el-form-item>
                            <el-form-item label="支付方式">
                                <el-radio v-model="payType" label="alipay">
                                    <img src="../assets/alilogo.png" style="width:20px;vertical-align: bottom;">
                                    支付宝
                                </el-radio>
                                <br/>
                                <el-radio v-model="payType" label="wechat_web">
                                    <img src="../assets/wxlogo.png" style="width:20px;vertical-align: bottom;">
                                    微信
                                </el-radio>
                            </el-form-item>
                            <div class="attention-important" v-if="XcdNotice" style="margin-top:10px;" @click="handleShowNotice">
                                <img src="../assets/notice_icon.png" 
                                style="width:14px;height:14px;margin-right:5px;"/>
                                {{XcdNotice && XcdNotice.Title}} 公告按时发顺丰
                                <img src="../assets/notice_icon_right.png"
                                style="width:8px;height:12px;margin-left:10px;"/>
                            </div>
                        </el-form>
                    </div> 
                </div>
                <div style="text-align:center;margin:30px 0">
                    <el-button type="primary" style="width:200px" @click="payFee">立即办理</el-button>
                </div>
                <div style="color:#97A3B4;font-size:12px;text-align: center;">
                    注：交通违法代缴的办理周期为<span style="color:#002257">2-5个工作日</span>。现场单或已领处罚单决定书可直接交款，请须知！如有疑问，请参见<span style="color:#002257;cursor: pointer;" @click="gotoHelp">常见问题</span>。
                    <p style="margin-top:10px">我同意<span style="color:#002257;cursor: pointer;" @click="gotoAgreement">《服务条款》</span>中的说明。</p>
                </div>
            </el-card>
        </div>
        
    </div>
</template>
<script>
import payDailog from './component/PayDailog.vue'
import login from './component/Login.vue'
import help from './component/Help.vue'
import agree from './component/Agree.vue'
export default {
        components:{
            'paydailog': payDailog,
            'login':login,
            'help':help,
            'agree': agree
        },
    data(){
        return {
            illegal:{},
            phone:'',
            driveNo: '',
            drive_file_number: '',
            drive_bar_code: '',
            driveUrl: '',
            travelUrl: '',
            JSZTravelUrl: '',
            JSZDriveUrl: '',
            price:0,
            ownFree:0,
            lateFree:0,
            date:'',
            payType: 'alipay',
            out_trade_no:'',
            showpay:false,
            paysrc:'',
            loginModel:false,
            helpModel: false,
            agreeModel: false,
            UserTel: window.localStorage.UserTel || '',
            showapp: false,
            XcdNotice: null
        }
    },
    computed:{
        totalPrice(){
            let price = Number(this.price * 100);
            let totalPrice = Math.round(price) + Math.round(this.ownFree * 100) + Math.round(this.lateFree * 100);
            return totalPrice || 0
        }
    },
    mounted(){
        if(window.localStorage.illegal){
            try{
                this.illegal = JSON.parse(window.localStorage.illegal)
                this.price = this.illegal.Fine;
                this.date = this.illegal.OccTime.substring(0, 10);
                this.phone = window.localStorage.UserTelAll
                this.illegal.FreeRuleObject = {}
                this.getRule()
                // this.getVipFee()
            }
            catch{
                this.$router.go(-1)
            }
            
        }else{
            this.$router.go(-1)
        }
    },
    methods:{
         getNotice() {
                this.$request('v3/violation/view/notice').then((xhr, res) => {
                    if (res.code === 0 && res.data) {
                        if (res.data.XcdHave) {
                            this.XcdNotice = res.data.XcdNotice;
                        }
                    } else {
                        this.XcdNotice = null;
                    }
                }).catch(() => {
                    this.XcdNotice = null;
                });
            },
            handleShowNotice() {
                this.$alert(this.XcdNotice.Content, this.XcdNotice.Title, {
                    confirmButtonText: '我知道了',
                    callback: () => {
                        this.$router.push({
                            path: '/paying'
                        })
                    }
                });
            },
        // app(show){
        //     this.showapp = show
        // },
        getRule() {
            this.$request('v3/violation/submit_rule',{
                "vio_id":this.illegal.ViolationId,
                "car_no": this.illegal.CarNo,
                "city_code": this.illegal.Locationid
                }).then((xhr, res) => {
                if (res.code == 0) {
                    this.ownFree = res.data.CooperFee ? Number((res.data.CooperFee / 100).toFixed(2)) : 0
                    this.illegal.FreeRuleObject.drive_no = res.data.NeedJszNo//驾驶证号
                    this.illegal.FreeRuleObject.drive_file_number = res.data.NeedJszFileNo//驾驶证档案编号
                    this.illegal.FreeRuleObject.drive_bar_code = res.data.NeedJszBarCode//驾驶证条形码

                    this.illegal.FreeRuleObject.drive_licence = res.data.NeedXszFront //行驶证正面
                    this.illegal.FreeRuleObject.travel_licence = res.data.NeedXszBack//行驶证反面

                    this.illegal.FreeRuleObject.jsz_drive_licence = res.data.NeedJszFront//驾驶证正面
                    this.illegal.FreeRuleObject.jsz_travel_licence = res.data.NeedJszBack//驾驶证反面
                }
            });
            
        },
        getVipFee() {
            // let self = this;
            this.$request('v3/violation/fee',{
                vio_id: this.illegal.ViolationId,
                car_no: this.illegal.CarNo,
                fine: (this.price * 100).toFixed(0)
            }).then((xhr, res) => {
                if (res.code == 0) {
                    this.lateFree = res.data.LateFree ? Number((res.data.LateFree / 100).toFixed(2)) : 0
                    this.ownFree = res.data.OwnFree ? Number((res.data.OwnFree / 100).toFixed(2)) : 0
                }
            });
        },
         // 上传行驶证正面
        chooseImage() {
            this.$refs.file.click();
        },
        // 上传行驶证反面
        chooseTravel() {
            this.$refs.XSZTravel.click();
        },
        // 上传驾驶证正面
        chooseJSZDrive() {
            this.$refs.JSZDrive.click();
        },
        // 上传驾驶证正面
        chooseJSZTravel() {
            this.$refs.JSZTravel.click();
        },
        // 上传行驶证正面照
        uploader() {
            let list = this.$refs.file.files;
            if (list.length != 1) {
                self.$message.error('最多只能选择1张行驶证。');
                return
            }
            
            let item = {
                name:list[0].name,
                size:list[0].size,
                file:list[0]
            }
            this.html5Reader(list[0],item,'driveUrl')
        },
        // 上传行驶证正面照
        uploaderXSZTravel() {
            let list = this.$refs.XSZTravel.files;
            if (list.length != 1) {
                self.$message.error('最多只能选择1张行驶证。');
                return
            }
            
            let item = {
                name:list[0].name,
                size:list[0].size,
                file:list[0]
            }
            this.html5Reader(list[0],item,'travelUrl')
        },
        // 上传驾驶证正面照
        uploaderJSZDrive() {
            let list = this.$refs.JSZDrive.files;
            if (list.length != 1) {
                self.$message.error('最多只能选择1张驾驶证。');
                return
            }
            
            let item = {
                name:list[0].name,
                size:list[0].size,
                file:list[0]
            }
            this.html5Reader(list[0],item,'JSZDrive')
        },
        // 上传驾驶证正面照
        uploaderJSZTravel() {
            let list = this.$refs.JSZTravel.files;
            if (list.length != 1) {
                self.$message.error('最多只能选择1张驾驶证。');
                return
            }
            
            let item = {
                name:list[0].name,
                size:list[0].size,
                file:list[0]
            }
            this.html5Reader(list[0],item,'JSZTravel')
        },
        html5Reader: function(file, item, name) {
            let imgSrc = new Image();
            let reader = new FileReader();
            reader.onload = (e) => {
                imgSrc.src = e.srcElement.result;
                this.$set(item, 'src', e.srcElement.result);
                let self = this;
                imgSrc.onload = function() {
                    // 图片原始尺寸
                    var originWidth = this.width;
                    var originHeight = this.height;
                    // 最大尺寸限制
                    var maxWidth = 600, maxHeight = 600;
                    // 目标尺寸
                    var targetWidth = originWidth, targetHeight = originHeight;
                    // 图片尺寸超过400x400的限制
                    if (originWidth > maxWidth || originHeight > maxHeight) {
                        if (originWidth / originHeight > maxWidth / maxHeight) {
                            // 更宽，按照宽度限定尺寸
                            targetWidth = maxWidth;
                            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                        } else {
                            targetHeight = maxHeight;
                            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                        }
                    }
                    let canvas = document.getElementById('canvas');
                    let context = canvas.getContext('2d');
                    // canvas对图片进行缩放
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    // 清除画布
                    context.clearRect(0, 0, targetWidth, targetHeight);
                    // 图片压缩
                    context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);
                    // canvas转为blob并上传
                    canvas.toBlob(function (blob) {
                    //    var b = {
                    //         file: blob,
                    //         name: item.name,
                    //         size: blob.size,
                    //         src: imgSrc.src
                    //     }
                        const formData = new FormData();
                        formData.append("image", blob, item.name);

                        // const formData = new FormData();
                        // formData.append("image", file);

                        self.$message.info("正在上传");
                        const xhr = new XMLHttpRequest();
                        xhr.upload.addEventListener('progress', self.uploadProgress, false);
                        xhr.open('POST', 'https://mys4s.cn/car/upload_report_pic', true);
                        xhr.send(formData);
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                                let data = JSON.parse(xhr.response)
                                if(data.code == 0) {
                                    self.$message.success("上传成功");
                                    if(name === 'ticket') {
                                        self.ticketUrl = data.data
                                    }else if(name === 'JSZTravel') {
                                        self.JSZTravelUrl = data.data
                                    }else if(name === 'JSZDrive') {
                                        self.JSZDriveUrl = data.data
                                    }else if(name === 'travelUrl') {
                                        self.travelUrl = data.data
                                    }else if(name === 'driveUrl') {
                                        self.driveUrl = data.data
                                    }
                                } else {
                                    self.$message.error(data.msg);
                                }
                            } else {
                                self.$message.error('图片上传失败,请重新上传');
                            }
                        }
                    },file.type ||  'image/png');
                }
            }
            reader.readAsDataURL(file);
        },
        getLogin(){
            this.$emit('getLogin')
        },
         payFee() {
            if (!window.localStorage.UserTel){
                this.loginModel = true
                this.$message.error('请您先登录')
                return
            } 
            let drivenoReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            let telReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (!telReg.test(this.phone)) {
                this.$message.error('请输入正确的手机号码');
                return;
            }
            if(this.illegal.FreeRuleObject && this.illegal.FreeRuleObject.drive_no == 1) {
                if(!this.driveNo) {
                    this.$message.error('请输入驾驶证号');
                    return;
                }else if (!drivenoReg.test(this.driveNo)) {
                    this.$message.error('请输入正确的驾驶证号');
                    return;
                }
            }
            if(this.illegal.FreeRuleObject && this.illegal.FreeRuleObject.drive_file_number == 1) {
                if (!this.drive_file_number) {
                    this.$message.error('请输入驾驶证档案编号');
                    return;
                }
            }
            if(this.illegal.FreeRuleObject && this.illegal.FreeRuleObject.drive_bar_code == 1) {
                if (!this.drive_bar_code) {
                    this.$message.error('请输入驾驶证条形码编号');
                    return;
                }
            }
            if(this.illegal.FreeRuleObject && this.illegal.FreeRuleObject.drive_licence == 1) {
                if (!this.driveUrl) {
                    this.$message.error('请先上传行驶证正面照');
                    return;
                }
            }
            if(this.illegal.FreeRuleObject && this.illegal.FreeRuleObject.travel_licence == 1) {
                if (!this.travelUrl) {
                    this.$message.error('请先上传行驶证反面照');
                    return;
                }
            }
            if(this.illegal.FreeRuleObject && this.illegal.FreeRuleObject.jsz_drive_licence == 1) {
                if (!this.JSZDriveUrl) {
                    this.$message.error('请先上传驾驶证正面照');
                    return;
                }
            }
            if(this.illegal.FreeRuleObject && this.illegal.FreeRuleObject.jsz_travel_licence == 1) {
                if (!this.JSZTravelUrl) {
                    this.$message.error('请先上传驾驶证反面照');
                    return;
                }
            }
            this.GenerateOrders();
        },
        // 提交订单
        GenerateOrders() {
            if (!window.localStorage.UserTel){
                this.loginModel = true
                this.$message.error('请您先登录')
                return
            }
            let self = this;
            let price = Number(this.price * 100)
            let totalPrice = Number(price + Math.round(this.ownFree * 100) + Math.round(this.lateFree * 100))
            let param = {
                formid: '',
                fine: price, // 罚金
                lateFree:this.lateFree? Math.round(this.lateFree * 100) : 0,
                ownFree: Math.round(this.ownFree * 100), // 服务费
                totalPrice: totalPrice, // 总金额
                vio_time: this.date, // 文章时间：格式：2017-12-13
                carno: this.illegal.CarNo || '',
                vio_id: this.illegal.ViolationId || '',
                mobile: this.phone || window.localStorage.UserTelAll,
                drive_no: this.driveNo || '',  // 驾驶证号
                drive_url: this.driveUrl || '', // 行驶证正面
                travel_url: this.travelUrl || '', // 行驶证反面
                jsz_drive_url: this.JSZDriveUrl || '', // 驾驶证正面
                jsz_travel_url: this.JSZTravelUrl || '', // 驾驶证反面
                vin: this.illegal.vin || '',
                engion: this.illegal.engine || '',
                drive_bar_code: this.drive_bar_code || '',
                drive_file_number: this.drive_file_number || '',
                car_type:window.localStorage.car_type || ''
            }
            if(this.payType === 'wechat_web') {
                param.pay_method ='wechat_web'
            }
            this.$request('v3/violation/web/order/create', param).then((xhr, res) => {
                if(res.code == 20022) {
					self.loginModel = true
					return;
				}
                if (res.code >= 40000 && res.code < 50000) {
					self.loginModel = true
                    return;
                }
                if (res.code == 0) {
                    self.paysrc = this.payType === 'wechat_web' ? res.data.CodeImg : res.data.qr_code_img
                    self.out_trade_no = res.data.out_trade_no
                    self.showpay = true
                } else {
                    this.$message.error(res.msg);
                }
            });
           
        },
        // 常见问题
        gotoHelp() {
            this.helpModel = true
        },
        // 服务协议
        gotoAgreement() {
            this.agreeModel = true
        },
    }
}
</script>
<style scoped>
.tickDetail p{
    text-align: right;
}
.tickDetail .el-form-item{
    border-bottom: 1px solid #E6E6E6;
    margin-bottom:0px;
    padding: 15px 5px;
}



.payform .el-form-item{
    margin-right: 30px;
}

.vio-header{
    line-height: 60px;
    /* border-bottom: 1px solid #EBEDF7;
    background: #fff; */
    display: flex;
    align-items: center;
    position: relative;
}

.pay-container{
    display: flex;
    
}
.form-title{
    margin-bottom: 30px;
    display: flex;
    align-items: center;
}
.form-title .fine{
    background: rgba(255, 0, 0, .1);
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 12px;
    color: red;
    margin-left: 10px;
}
.upload{
    box-sizing: border-box;
    width: 200px;
    height: 100px;
    display: flex;
    flex-direction: column;
    border: 1px solid #EBEDF7;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}
</style>



